import moment from 'moment'

const regexCheckPhone = /^(0\d{9}|\+\d{1,3}\s?\d{6,15})$/
const regexCheckSpecialChar = /[!@#$%^&*(),.?":{}|<>`0-9]/
const regexCheckEmail =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i

export const validateExchangeRate = (input: string, currencyMoney: string, currencyFee: string) => {
  if (input && currencyMoney != '0' && currencyFee != '0' && !isNaN(parseInt(input))) {
    if (currencyMoney != currencyFee && input == '1') return false
    else if (currencyMoney == currencyFee && input != '1') return false
    else return true
  } else return false
}

export const validatePhoneNumber = (input: string) => {
  if (input) return regexCheckPhone.test(input)
  else return false
}

export const validateLandlinePhoneNumber = (input: string) => {
  if (input) return input.length >= 8 && input.length <= 11
  else return false
}

export const validateSpecialChar = (input: string) => {
  if (input) return !regexCheckSpecialChar.test(input)
  else return false
}

export const validateEmail = (input: string) => {
  if (input) return regexCheckEmail.test(input)
  else return false
}

export const validateBirthDay = (input: string) => {
  let year = moment().year()
  let day = moment().date()
  let month = moment().month() + 1
  let yearInput = moment(input, 'YYYY/MM/DD').year()
  let dayInput = moment(input, 'YYYY/MM/DD').date()
  let monthInput = moment(input, 'YYYY/MM/DD').month() + 1
  if (year > yearInput) return true
  else if (year == yearInput) {
    if (month > monthInput) return true
    else if (month == monthInput) {
      if (day > dayInput || day == dayInput) return true
      else return false
    } else return false
  } else return false
}

export const validateEffectiveDate = (startDate: string, expireDate: string) => {
  let yearStart = moment(startDate).year()
  let dayStart = moment(startDate).date()
  let monthStart = moment(startDate).month() + 1
  let yearExpire = moment(expireDate).year()
  let dayExpire = moment(expireDate).date()
  let monthExpire = moment(expireDate).month() + 1
  if (yearExpire > yearStart) return true
  else if (yearExpire == yearStart) {
    if (monthExpire > monthStart) return true
    else if (monthExpire == monthStart) {
      if (dayExpire > dayStart || dayExpire == dayStart) return true
      else return false
    } else return false
  } else return false
}

export const validateIdentity = (input: string) => {
  if (input) return input.length === 9 || input.length === 12
  else return false
}
export const validateId = (input: string) => {
  if (!input) return false;
  // Chỉ cho phép chữ, số và dấu "-", nhưng "-" không ở đầu/cuối, không liên tiếp
  const regex = /^(?!-)([A-Za-z0-9]+(-[A-Za-z0-9]+)*)(?<!-)$/;
  return regex.test(input);
}

export const validateTaxNumber = (input: string) => {
  if (input) {
    if (input.length === 10) return true
    if (input.length === 14) {
      let regex = /([0-9]{10}-[0-9]{3})/
      return regex.test(input)
    }
  } else return false
}

export const validateExpireDate = (startDate: string, expireDate: string) => {
  if (startDate && expireDate) {
    let checkYear = moment(expireDate).isSame(startDate, 'year')
    if (checkYear) {
      let checkMonth = moment(expireDate).isSame(startDate, 'month')
      if (checkMonth) {
        let checkDay = moment(expireDate).isSame(startDate, 'day')
        if (checkDay) {
          let checkHour = moment(expireDate).isSame(startDate, 'hour')
          if (checkHour) {
            let checkMinute = moment(expireDate).isSame(startDate, 'minute')
            if (checkMinute) {
              return true
            } else {
              let test = moment(expireDate).isAfter(startDate, 'minute')
              return test
            }
          } else {
            let test = moment(expireDate).isAfter(startDate, 'hour')
            return test
          }
        } else {
          let test = moment(expireDate).isAfter(startDate, 'day')
          return test
        }
      } else {
        let test = moment(expireDate).isAfter(startDate, 'month')
        return test
      }
    } else {
      let test = moment(expireDate).isAfter(startDate, 'year')
      return test
    }
  } else return false
}
